import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { Company } from '../../schema/company';

interface CompanyFromInputProps {
  required?: boolean;
  value?: number | null;
  onChange?: (value: number | null) => void;
}

const CompanyFromInput: React.FC<CompanyFromInputProps> = ({
  required,
  value,
  onChange
}: CompanyFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [companyList, setCompanyList] = useState<Company[]>([]);
  const [selectedValue, setSelectedValue] = useState<Company | null>(null);

  useEffect(() => {
    if (value != null) {
      const company = companyList.find((data) => data.id == value);
      if (company) {
        setSelectedValue(company);
        return;
      }
      api.get<Company>(`/company/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setCompanyList([data]);
      });
    } else {
      api.get<Company[]>(`/company`).then((res) => {
        const { data } = res;
        setCompanyList(data);
      });

      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('company_name', searchKeyword);
        // searchParams.set('limit', '10');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanyList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={companyList}
      getOptionLabel={(option) => (option?.company_name ? option.company_name : '')}
      renderInput={(params) => (
        <TextField {...params} label="บริษัท" required={required} placeholder="บริษัท" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue) => {
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default CompanyFromInput;
